var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"absolute","bottom":"10px","right":"16px","min-width":"20px","font-size":"14px","z-index":"100000000","cursor":"pointer"},on:{"click":function($event){return _vm.showTour()}}},[_c('i',{staticClass:"fa fa-lightbulb-o fa-2x",attrs:{"title":_vm.take_tour_string}})])
}
var staticRenderFns = []

export { render, staticRenderFns }